import { ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { TwoFactorEnroll } from "./TwoFactorCard";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_client-portal-252/artifacts/ymujr84m_Logo%20blitzz%20%2B%20BYB%20ok%20sans%20fond%20copie.png";

// Écran bloquant : le rôle exige la 2FA et l'utilisateur ne l'a pas encore configurée
export default function TwoFactorGate() {
  const { axiosAuth, checkAuth, logout, user } = useAuth();
  const api = axiosAuth();
  return (
    <div className="min-h-screen bg-[#0b0811] text-white flex items-center justify-center p-6" data-testid="twofa-gate">
      <div className="w-full max-w-2xl bg-[#14101c] border border-white/10 rounded-2xl p-8">
        <img src={LOGO_URL} alt="Blitzz" className="h-12 object-contain mb-6" />
        <div className="flex items-center gap-2 mb-2"><ShieldCheck className="w-5 h-5 text-[#f7c935]" /><h1 className="text-xl font-black">Sécurisez votre compte</h1></div>
        <p className="text-sm text-slate-400 mb-6">Bonjour {user?.first_name || user?.name}. La double authentification est obligatoire pour le rôle <b>{user?.role}</b>. Cette étape ne prend qu'une minute.</p>
        <TwoFactorEnroll api={api} forced onEnabled={() => setTimeout(() => checkAuth(), 400)} />
        <div className="mt-6 flex justify-between items-center text-xs text-slate-500">
          <span>Après activation, notez vos codes de secours puis cliquez sur « Continuer ».</span>
          <div className="flex gap-3">
            <button onClick={() => checkAuth()} className="text-[#f7c935] hover:underline" data-testid="twofa-gate-continue">Continuer</button>
            <button onClick={logout} className="inline-flex items-center gap-1 hover:text-white" data-testid="twofa-gate-logout"><LogOut className="w-3 h-3" /> Se déconnecter</button>
          </div>
        </div>
      </div>
    </div>
  );
}
